import Cookies from "js-cookie"
import { useContext, useEffect, useState } from "react"
import { NavLink, useNavigate } from "react-router-dom"

import MyContext from "../../context/context"

// MUI
import { ArrowForward, EmailOutlined, HomeSharp, LockOutlined } from "@mui/icons-material"
import { AppBar, Avatar, Box, Button, Chip, CircularProgress, Container, Divider, Fade, Grid, IconButton, Paper, Stack, TextField, Toolbar, Typography, useTheme } from "@mui/material"

export default function StudentLogin({ snackbar }) {
	const theme = useTheme()
	const api = useContext(MyContext)
	const navi = useNavigate()
	const auth = Cookies.get("authuser")
	const [action, setAction] = useState("")

	useEffect(() => {
		if (auth === "student") {
			navi("/student/home", { replace: true })
		}
	}, [auth])

	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")

	const login = (e) => {
		e.preventDefault()
		setAction("working")
		var formData = new FormData()
		formData.append("login-student", email)
		formData.append("password", password)
		fetch(api.api.login, {
			method: "post",
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				setAction("")
				snackbar(data.message)
				if (data.status === true) {
					navi("/student/home", { replace: true })
				}
			})
	}

	useEffect(() => {
		window.location.reload("https://app.spywarecomputers.com/student")
	}, [])

	return (
		<Box
			sx={{
				minHeight: "100vh",
				background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 50%, ${theme.palette.primary.dark} 100%)`,
				position: "relative",
				overflow: "hidden",
				"&::before": {
					content: '""',
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					background: "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
					pointerEvents: "none",
				},
			}}
			pb={10}
		>
			<AppBar
				position="fixed"
				elevation={0}
				sx={{
					background: "rgba(255, 255, 255, 0.1)",
					backdropFilter: "blur(10px)",
					borderBottom: "1px solid rgba(255,255,255,0.2)",
					zIndex: 1100,
				}}
			>
				<Toolbar sx={{ minHeight: { xs: 56, sm: 64 } }}>
					<img src="logo_text_white.png" style={{ width: 150, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }} alt="Logo" />
					<Typography flexGrow={1} />
					<IconButton
						edge="end"
						sx={{
							color: "white",
							"&:hover": {
								background: "rgba(255,255,255,0.15)",
								transform: "scale(1.1)",
								transition: "all 0.3s ease",
							},
						}}
						onClick={() => navi("/")}
					>
						<HomeSharp />
					</IconButton>
				</Toolbar>
			</AppBar>

			<Container maxWidth="sm" sx={{ position: "relative", zIndex: 1, pt: { xs: 9, sm: 10 } }}>
				<Grid container sx={{ py: { xs: 3, md: 5 }, minHeight: "calc(100vh - 120px)" }} alignItems="center">
					<Grid item xs={12}>
						<Fade in timeout={800}>
							<Paper
								elevation={12}
								sx={{
									borderRadius: 3,
									overflow: "hidden",
									background: "rgba(255, 255, 255, 0.98)",
									backdropFilter: "blur(20px)",
									boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
								}}
							>
								{/* Student Login Section */}
								<Box
									sx={{
										background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
										padding: 2.5,
										textAlign: "center",
										position: "relative",
									}}
								>
									<Avatar
										sx={{
											width: 60,
											height: 60,
											margin: "0 auto 12px",
											bgcolor: "rgba(255,255,255,0.25)",
											backdropFilter: "blur(10px)",
											border: "3px solid rgba(255,255,255,0.5)",
											boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
										}}
									>
										<LockOutlined sx={{ fontSize: 30, color: "white" }} />
									</Avatar>
									<Typography
										fontSize={22}
										fontWeight={700}
										color="white"
										sx={{
											textShadow: "0 2px 8px rgba(0,0,0,0.2)",
											letterSpacing: 0.5,
										}}
									>
										Student Login
									</Typography>
									<Typography fontSize={13} color="rgba(255,255,255,0.9)" mt={0.5}>
										Welcome back! Please login to continue
									</Typography>
								</Box>

								<Box component="form" onSubmit={login} sx={{ p: 3 }}>
									<Stack spacing={2.5}>
										<TextField
											fullWidth
											type="email"
											label="Email Address"
											value={email}
											onChange={(event) => setEmail(event.target.value)}
											required
											variant="outlined"
											InputProps={{
												startAdornment: <EmailOutlined sx={{ mr: 1, color: "primary.main" }} />,
											}}
											sx={{
												"& .MuiOutlinedInput-root": {
													"&:hover fieldset": {
														borderColor: "primary.main",
														borderWidth: 2,
													},
													"&.Mui-focused fieldset": {
														borderColor: "primary.main",
													},
												},
											}}
										/>
										<TextField
											fullWidth
											type="password"
											label="Password"
											value={password}
											onChange={(event) => setPassword(event.target.value)}
											required
											variant="outlined"
											InputProps={{
												startAdornment: <LockOutlined sx={{ mr: 1, color: "primary.main" }} />,
											}}
											sx={{
												"& .MuiOutlinedInput-root": {
													"&:hover fieldset": {
														borderColor: "primary.main",
														borderWidth: 2,
													},
													"&.Mui-focused fieldset": {
														borderColor: "primary.main",
													},
												},
											}}
										/>
									</Stack>

									<Button
										fullWidth
										variant="contained"
										color="primary"
										size="medium"
										type="submit"
										disabled={action === "working"}
										endIcon={action !== "working" && <ArrowForward />}
										sx={{
											mt: 2.5,
											py: 1.3,
											fontSize: 15,
											fontWeight: 600,
											textTransform: "none",
											borderRadius: 2,
											boxShadow: `0 4px 12px ${theme.palette.primary.main}66`,
											background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
											"&:hover": {
												boxShadow: `0 6px 16px ${theme.palette.primary.main}80`,
												transform: "translateY(-2px)",
												transition: "all 0.3s ease",
											},
											"&:disabled": {
												background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.light} 100%)`,
											},
										}}
									>
										{action === "working" ? <CircularProgress color="inherit" size={24} /> : "Login Now"}
									</Button>

									<Stack direction="row" spacing={{ xs: 0, md: 2 }} mt={2.5} justifyContent="space-between" flexWrap="wrap" gap={1}>
										<Button
											variant="text"
											color="error"
											size="small"
											onClick={() => navi("/reset-student")}
											sx={{
												textTransform: "none",
												fontWeight: 500,
												"&:hover": {
													background: "rgba(211, 47, 47, 0.08)",
												},
											}}
										>
											Forgot Password?
										</Button>
										<Button
											variant="text"
											color="success"
											size="small"
											onClick={() => navi("/admission")}
											sx={{
												textTransform: "none",
												fontWeight: 500,
												"&:hover": {
													background: "rgba(46, 125, 50, 0.08)",
												},
											}}
										>
											New Student? Join Now
										</Button>
									</Stack>

									<Box mt={2.5}>
										<NavLink
											to="/terms&conditions"
											style={{
												color: "#666",
												fontSize: 11,
												textDecoration: "none",
											}}
										>
											*By continuing, you agree to our terms and conditions
										</NavLink>
									</Box>
								</Box>

								<Divider sx={{ mx: 3 }}>
									<Chip
										label="FRANCHISE LOGIN"
										color="primary"
										size="small"
										sx={{
											fontWeight: 600,
											letterSpacing: 0.5,
										}}
									/>
								</Divider>

								<Box sx={{ p: 3, pt: 2.5, textAlign: "center", bgcolor: "grey.50" }}>
									<Typography fontSize={15} fontWeight={600} color="text.secondary" mb={1.5}>
										Are you a franchise partner?
									</Typography>
									<Button
										fullWidth
										variant="outlined"
										color="primary"
										size="medium"
										onClick={() => navi("/login-franchise")}
										endIcon={<ArrowForward />}
										sx={{
											py: 1.3,
											fontSize: 14,
											fontWeight: 600,
											textTransform: "none",
											borderRadius: 2,
											borderWidth: 2,
											"&:hover": {
												borderWidth: 2,
												background: `${theme.palette.primary.main}14`,
												transform: "translateY(-2px)",
												transition: "all 0.3s ease",
											},
										}}
									>
										Franchise Login
									</Button>
								</Box>
							</Paper>
						</Fade>
					</Grid>
				</Grid>
			</Container>

			{/* Footer Social Links */}
			{/* <Box
				sx={{
					position: "fixed",
					width: "100%",
					bottom: 0,
					left: 0,
					background: "rgba(255, 255, 255, 0.1)",
					backdropFilter: "blur(10px)",
					borderTop: "1px solid rgba(255,255,255,0.2)",
					py: 1.5,
					zIndex: 1000
				}}
			>
				<Typography
					textAlign="center"
					fontSize={13}
					color="white"
					fontWeight={500}
					mb={1}
					sx={{ textShadow: "0 1px 2px rgba(0,0,0,0.3)" }}
				>
					Follow us on
				</Typography>
				<Box textAlign="center">
					{[
						{ icon: <Instagram />, url: "https://www.instagram.com/spywarecomputers/" },
						{ icon: <Facebook />, url: "https://www.facebook.com/profile.php?id=61556216739412" },
						{ icon: <YouTube />, url: "https://www.youtube.com/channel/UC23IqIFehYq6DTY1_857aOA" },
						{ icon: <WhatsApp />, url: "https://wa.me/917631473503" },
						{ icon: <Call />, url: "tel:917631473503" }
					].map((social, index) => (
						<IconButton
							key={index}
							size="medium"
							onClick={() => (window.location.href = social.url)}
							sx={{
								color: "white",
								mx: 0.5,
								"&:hover": {
									background: "rgba(255,255,255,0.2)",
									transform: "scale(1.15) translateY(-2px)",
									transition: "all 0.3s ease"
								}
							}}
						>
							{social.icon}
						</IconButton>
					))}
				</Box>
			</Box> */}
		</Box>
	)
}
